/**
 * NWScriptInstructionInfo enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file NWScriptInstructionInfo.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export const NWScriptInstructionInfo: {[key: number]: {name: string}} = {
  1 : { 
    name: 'CPDOWNSP', 
  },
  2 : { 
    name: 'RSADD', 
  },
  3 : { 
    name: 'CPTOPSP', 
  },
  4 : { 
    name: 'CONST', 
  },
  5 : { 
    name: 'ACTION', 
  },
  6 : { 
    name: 'LOGANDII', 
  },
  7 : { 
    name: 'LOGORII', 
  },
  8 : { 
    name: 'INCORII', 
  },
  9 : { 
    name: 'EXCORII', 
  },
  10 : { 
    name: 'BOOLANDII', 
  },
  11 : { 
    name: 'EQUAL', 
  },
  12 : { 
    name: 'NEQUAL', 
  },
  13 : { 
    name: 'GEQ', 
  },
  14 : { 
    name: 'GT', 
  },
  15 : { 
    name: 'LT', 
  },
  16 : { 
    name: 'LEQ', 
  },
  17 : { 
    name: 'SHLEFTII', 
  },
  18 : { 
    name: 'SHRIGHTII', 
  },
  19 : { 
    name: 'USHRIGHTII', 
  },
  20 : { 
    name: 'ADD', 
  },
  21 : { 
    name: 'SUB', 
  },
  22 : { 
    name: 'MUL', 
  },
  23 : { 
    name: 'DIV', 
  },
  24 : { 
    name: 'MOD', 
  },
  25 : { 
    name: 'NEG', 
  },
  26 : { 
    name: 'COMPI', 
  },
  27 : { 
    name: 'MOVSP', 
  },
  28 : { 
    name: 'STORE_STATEALL', 
  },
  29 : { 
    name: 'JMP', 
  },
  30 : { 
    name: 'JSR', 
  },
  31 : { 
    name: 'JZ', 
  },
  32 : { 
    name: 'RETN', 
  },
  33 : { 
    name: 'DESTRUCT', 
  },
  34 : { 
    name: 'NOTI', 
  },
  35 : { 
    name: 'DECISP', 
  },
  36 : { 
    name: 'INCISP', 
  },
  37 : { 
    name: 'JNZ',
  },
  38 : { 
    name: 'CPDOWNBP', 
  },
  39 : { 
    name: 'CPTOPBP', 
  },
  40 : { 
    name: 'DECIBP', 
  },
  41 : { 
    name: 'INCIBP', 
  },
  42 : { 
    name: 'SAVEBP', 
  },
  43 : { 
    name: 'RESTOREBP',
  },
  44 : { 
    name: 'STORE_STATE', 
  },
  45 : { 
    name: 'NOP', 
  },
  46 : { 
    name: 'T', 
  }
};